export interface WorkerGroupHeaderProps {
  displayName: string;
  count: number;
  /** Ties the heading to its `<section aria-labelledby>` so the rotor can jump between workers. */
  id: string;
}

/**
 * The sticky caption above one worker's assignments for the shown day.
 *
 * Region deliberately does not appear here. At 369px of content `Gulf Coast · 2 assignments`
 * crowds out the name the header exists to caption, and region is already visible as a
 * filter chip when it's being filtered on and in the detail sheet when it isn't.
 */
export function WorkerGroupHeader({ displayName, count, id }: WorkerGroupHeaderProps) {
  return (
    <h2
      id={id}
      className="sticky top-0 z-10 bg-slate-50 border-y border-slate-200 px-3 py-2 flex items-baseline gap-3"
    >
      <span className="text-sm font-semibold text-brand-charcoal truncate">{displayName}</span>
      <span className="ml-auto shrink-0 text-xs text-slate-500 tabular-nums font-normal">
        {count === 1 ? '1 assignment' : `${count} assignments`}
      </span>
    </h2>
  );
}
